module.exports = __webpack_public_path__ + "static/media/plus-icon.975e7ceb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/plus-icon.svg
// module id = 2157
// module chunks = 0